import getters from './leadGenGetters'
import actions from './leadGenActions'
import mutations from './leadGenMutations'

const STORAGE_KEY = 'leadGenFlow'

const loadFromStorage = () => {
  try {
    const data = sessionStorage.getItem(STORAGE_KEY)
    return data ? JSON.parse(data) : null
  } catch (error) {
    console.error('Failed to load from session storage:', error)
    return null
  }
}

const savedData = loadFromStorage()

const store = {
  namespaced: true,
  state: () => ({
    leadGenQuestions: savedData?.leadGenQuestions || [],
    answers: savedData?.answers || {},
    orgGuid: savedData?.orgGuid || null,
    orgId: null,
    orgType: savedData?.orgType || null,
    settings: savedData?.settings || {
      landingPageTitle: null,
      submissionPageBodyText: null,
      prequalHardCreditAllowed: false,
      purchaseFlow: false,
      refinanceFlow: false,
      prequalFlow: false,
      autoRunLpa: false,
      autoRunDu: false,
      conversationalFlow: false,
      name: null,
      orgIcon: null,
      orgAppIcon: null,
      servicerImageUrl: null,
      servicerInitials: null,
      partnerImageUrl: null,
      partnerInitials: null
    },
    currentQuestionIndex: savedData?.currentQuestionIndex || 0,
    formSubmitted: false,
    sac: savedData?.sac || null,
    leadId: savedData?.leadId || null,
    previewForm: false,
    previewQuestion: false,
    showLandingPage: true,
    hasVisitedLandingPage: false,
    // Conversational flow state
    isInConversationalFlow: savedData?.isInConversationalFlow || false,
    conversationalChatId: savedData?.conversationalChatId || null,
    conversationalLeadData: savedData?.conversationalLeadData || {},
    conversationalContactCollected: savedData?.conversationalContactCollected || false,
    conversationalLeadComplete: savedData?.conversationalLeadComplete || false,
    conversationalPrequalComplete: savedData?.conversationalPrequalComplete || false,
    conversationalMessages: savedData?.conversationalMessages || [],
    conversationalQuestionCounts: savedData?.conversationalQuestionCounts || null
  }),
  getters,
  actions,
  mutations
}

export default store
